module.exports = __webpack_public_path__ + "static/WithDraw-b811d37546b8d264dc56ca5e2c13e91b.png";